// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
        defaultDisplay: bcSfFilterConfig.custom.layout,
        showPlaceholderProductList: false,
        showRefineBy: true,
        changeMobileButtonLabel: true
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'is-sold-out',

    'soldOutLabelHtml': '<div class="grid-product__sold-out"><p>' + bcSfFilterConfig.label.sold_out + '</p></div>',
    'vendorHtml': '<p class="grid-product__vendor">{{vendor}}</p>',

    // Collage Template
    'productCollageItemHtml': '{{startCollageWrapper}}<div class="grid__item grid-product {{itemGridWidthClass}} {{soldOutClass}}" data-vendor="{{itemVendor}}">' +
                                '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
                                '<div class="grid-product__wrapper">' +
                                    '<div class="grid-product__image-wrapper">' +
                                        '<a class="grid-product__image-link" href="{{itemUrl}}">' +
                                            '<img class="grid-product__image" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                        '</a>' +
                                        '{{itemSoldOutLabel}}' +
                                    '</div>' +
                                    '<a href="{{itemUrl}}" class="grid-product__meta">' +
                                        '<span class="grid-product__title">{{itemTitle}}</span>' +
                                        '<span class="grid-product__price-wrap"><span class="long-dash">—</span>{{itemPrice}}</span>' +
                                        '{{itemVendor}}' +
                                    '</a>' +
                                '</div>' +
                            '</div>{{endCollageWrapper}}',

    // Grid Template currently used
    'productGridItemHtml': '<div class="grid__item grid-product one-half large--one-third {{soldOutClass}}" data-vendor="{{itemVendor}}">' +
                                '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
                                '<div class="grid-product__wrapper">' +
                                    '<div class="grid-product__image-wrapper">' +
                                        '<a class="grid-product__image-link" href="{{itemUrl}}">' +
                                            '{{imgHtml}}' +
                                        '</a>' +
                                        '{{itemSoldOutLabel}}' +
                                        '{{quickShopBtn}}' +
                                    '</div>' +
                                    '<span class="grid-product__meta">' +
                                        '<span class="grid-product__vendor"><a href="{{itemCollectionHandle}}">{{itemVendor}}</a></span>' +
                                        '<a href="{{itemUrl}}">' + 
                                            '<span class="grid-product__title">{{itemTitle}}</span>' +
                                        '</a>' + 
                                        '<span class="grid-product__price-wrap">{{itemPrice}}</span>' +
                                    '</span>' +
                                    `{{quickShopHtml}}` + 
                                '</div>' +
                            '</div>',

    // Pagination Template
    'previousHtml': '<span class="prev"><a href="{{itemUrl}}"><span class="icon-fallback-text"><span class="icon icon-arrow-left" aria-hidden="true"></span><span class="fallback-text">Previous</span></span></a></span>',
    'nextHtml': '<span class="next"><a href="{{itemUrl}}"><span class="icon-fallback-text"><span class="icon icon-arrow-right" aria-hidden="true"></span><span class="fallback-text">Next</span></span></a></span>',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
    'paginateHtml': '<div class="pagination">{{previous}}{{pageItems}}{{next}}</div>',
    'skeletonProductCollage':   '<div class="grid__item collage-grid__row bc-sf-filter-product-skeleton">'+
                                    '<div class="grid">' +
                                        '<div class="grid__item grid-product grid__item--large one-whole medium--two-thirds large--two-thirds bc-sf-filter-product-skeleton">' +
                                            '<div class="bc-sf-filter-skeleton-image" style="padding-top: 100%"></div>'+
                                            '<div class="bc-sf-filter-skeleton-meta card__info text-center"><span class="bc-sf-filter-skeleton-text bc-sf-filter-skeleton bc-sf-filter-skeleton-width3"></span></div>'+
                                        '</div>' +
                                        '<div class="grid__item grid-product grid__item--small one-whole medium--one-third large--one-third bc-sf-filter-product-skeleton">' +
                                            '<div class="bc-sf-filter-skeleton-image" style="padding-top: 100%"></div>'+
                                            '<div class="bc-sf-filter-skeleton-meta card__info text-center"><span class="bc-sf-filter-skeleton-text bc-sf-filter-skeleton bc-sf-filter-skeleton-width3"></span></div>'+
                                        '</div>' +
                                        '<div class="grid__item grid-product grid__item--small one-whole medium--one-third large--one-third bc-sf-filter-product-skeleton">' +
                                            '<div class="bc-sf-filter-skeleton-image" style="padding-top: 100%"></div>'+
                                            '<div class="bc-sf-filter-skeleton-meta card__info text-center"><span class="bc-sf-filter-skeleton-text bc-sf-filter-skeleton bc-sf-filter-skeleton-width3å"></span></div>'+
                                        '</div>' +
                                    '</div>' +
                                '</div>',
};

/************************** BUILD PRODUCT LIST **************************/

var is_three_row__product = false;
var is_reverse_row__product = false;
var three_row_index__product = 0;

jQ('#sortBy').off('change');
jQ(document).ready(() => {  
    const offsetTop = jQ('#bc-sf-filter-tree-mobile').offset().top;
    const height = jQ('#bc-sf-filter-tree-mobile').height();
    console.log(offsetTop, height)
    document.body.style.setProperty('--filter-offset-top', `${offsetTop + height}px`)
})
// Build Product Collage Item
BCSfFilter.prototype.buildProductCollageItem = function(data, index, totalProduct) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    if (index == 1) {
        is_three_row__product = false;
        is_reverse_row__product = false;
        three_row_index__product = 0;
    }

    // Get Template
    var itemHtml = bcSfFilterTemplate.productCollageItemHtml;

    var collection_product_count__product = totalProduct;
    var divisible_by_three__product = collection_product_count__product % 3;
    var remaining_length__product = collection_product_count__product - index;

    if (remaining_length__product > 3) {
        is_three_row__product = true;
    }
    if (remaining_length__product < 4 && three_row_index__product > 2) {
        is_three_row__product = false;
    }
    if (divisible_by_three__product == 0) {
        is_three_row__product = true;
    }

    // Wrapper for collage
    var startCollageWrapper = '';
    var endCollageWrapper = '';
    // Grid Width class
    var itemGridWidthClass = 'one-whole medium--one-half large--one-half';
    if (totalProduct == 1) {
        itemGridWidthClass = '';
    }
    if (is_three_row__product == true) {
        if (three_row_index__product > 2) {
            is_reverse_row__product = is_reverse_row__product ? false : true;
            three_row_index__product = 0;
        }

        // Add a specific class for grid item
        switch(three_row_index__product) {
            case 0:
                if (is_reverse_row__product) {
                    itemGridWidthClass = 'grid__item--small one-whole reverse';
                } else {
                    itemGridWidthClass = 'grid__item--large one-whole medium--two-thirds large--two-thirds';
                }
                break;
            case 1:
                if (is_reverse_row__product) {
                    itemGridWidthClass = 'grid__item--small one-whole reverse';
                } else {
                    itemGridWidthClass = 'grid__item--small one-whole medium--one-third large--one-third';
                }
                break;
            case 2:
                if (is_reverse_row__product) {
                    itemGridWidthClass = 'grid__item--large one-whole medium--two-thirds large--two-thirds reverse clearfix';
                } else {
                    itemGridWidthClass = 'grid__item--small one-whole medium--one-third large--one-third clearfix';
                }
                break;
            default:
                break;
        }

        if (three_row_index__product == 0) {
            startCollageWrapper += '<div class="grid__item collage-grid__row"><div class="grid">';
        }

        if (is_reverse_row__product && three_row_index__product == 0) {
            startCollageWrapper += '<div class="grid__item collage-grid__reverse--wrapper one-whole medium--one-third large--one-third"><div class="grid">';
        }

        if (is_reverse_row__product && three_row_index__product == 1) {
            endCollageWrapper += '</div></div>';
        }

        if (three_row_index__product == 2) {
            endCollageWrapper += '</div></div><div class="grid__row-separator"></div>';
        }

        if (three_row_index__product <= 2) {
            three_row_index__product += 1;
        }
    } else {
        if (collection_product_count__product == 1) {
        } else {
            if (remaining_length__product == 2) {
                endCollageWrapper = '<div class="grid__row-separator"></div>';
            }
            if (three_row_index__product <= 2) {
                three_row_index__product += 1;
            }
        }
    }
    itemHtml = itemHtml.replace(/{{startCollageWrapper}}/g, startCollageWrapper);
    itemHtml = itemHtml.replace(/{{endCollageWrapper}}/g, endCollageWrapper);
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // Add soldOut and onSale label
    if (soldOut) {
        itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, bcSfFilterTemplate.soldOutLabelHtml);
    } else {
        itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, '');
    }

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], 'grande') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Vendor
    // var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{vendor}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);

    itemHtml = itemHtml.replace(/{{itemCollectionHandle}}/g, Shopify.handleize(data.vendor));

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.sale_price + '</span>';
        itemPriceHtml += '<span class="grid-product__sale-price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
    } else {
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
    }
    if (priceVaries) {
        if (onSale) {
            itemPriceHtml += '<span class="grid-product__price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span>';
        } else {
            itemPriceHtml += '<span class="grid-product__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
        }
        itemPriceHtml += '<span class="icon-fallback-text"><span class="icon icon-plus grid-product__price-min" aria-hidden="true"></span><span class="fallback-text">+</span></span>';
    } else {
        if (onSale) {
            itemPriceHtml += '<span class="grid-product__price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span>';
        } else {
            itemPriceHtml += '<span class="grid-product__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add data json
    itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    
    // TODO: Find hook
    if(!window.BCSFBuildTimeout){
        window.BCSFBuildTimeout = setTimeout(window.restrictions.init, 1000)
    }
    
    return itemHtml;
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    
    var isEmailPhoneOrders = data.tags.includes('email-orders') || data.tags.includes('phone-orders') || data.tags.includes('INQUIRE')
    
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    var imgHtml = `
        <img 
            class="grid-product__image"
            loading="lazy"
            src="${this.optimizeImage(data.featured_image.src, '800x800')}"
            alt="${data.featured_image.alt}"
        >
    `
    if (data.images[1]) {
        imgHtml = `
            <div class="reveal">
                <img 
                    class="product--image"
                    loading="lazy"
                    src="${this.optimizeImage(data.featured_image.src, '800x800')}"
                    alt="${data.featured_image.alt}"
                />
                <img 
                    class="hidden" 
                    loading="lazy"
                    src="${this.optimizeImage(data.images[1].src, '800x800')}" 
                    alt="${data.images[1].alt}"
                />
            </div>
        `
    }
    itemHtml = itemHtml.replace(/{{imgHtml}}/g, imgHtml);

    
    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // Add soldOut
    if (soldOut) {
        itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, bcSfFilterTemplate.soldOutLabelHtml);
    } else {
        itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, '');
    }
    

    
    var quickShopHtml = `
        <div class="product-collection-hover">
            <div class="grid-product__meta grid-product__options">
                ${this.buildAddToCartOptions(data)}
            </div>
        </div>
    `
    if (soldOut || isEmailPhoneOrders) {
        quickShopHtml = ''
    }
    itemHtml = itemHtml.replace(/{{quickShopHtml}}/g, quickShopHtml)
    
    

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], 'grande') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Vendor
    // var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{vendor}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);

    itemHtml = itemHtml.replace(/{{itemCollectionHandle}}/g, Shopify.handleize(data.vendor));

    // Add Price
    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.sale_price + '</span>';
        itemPriceHtml += '<span class="grid-product__sale-price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
    } else {
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
    }
    if (priceVaries) {
        if (onSale) {
            itemPriceHtml += '<span class="grid-product__price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span>';
        } else {
            itemPriceHtml += '<span class="grid-product__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
        }
        itemPriceHtml += '<span class="icon-fallback-text"><span class="icon icon-plus grid-product__price-min" aria-hidden="true"></span><span class="fallback-text">+</span></span>';
    } else {
        if (onSale) {
            itemPriceHtml += '<span class="grid-product__price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span>';
        } else {
            itemPriceHtml += '<span class="grid-product__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add data json
    var self = this;
    var itemJson = {
      "id": data.id,
      "title": data.title,
      "handle": data.handle,
      "vendor": data.vendor,
      "variants": data.variants,
      "url": self.buildProductItemUrl(data),
      "options_with_values": data.options_with_values,
      "images": data.images,
      "available": data.available,
      "price_min": data.price_min,
  		"price_max": data.price_max,
  		"compare_at_price_min": data.compare_at_price_min,
  		"compare_at_price_max": data.compare_at_price_max,
    };
    itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    
    // TODO: Find hook
    if(!window.BCSFBuildTimeout){
        window.BCSFBuildTimeout = setTimeout(window.restrictions.init, 1000)
    }
    
    return itemHtml;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    /* start-initialize-bc-al */
    var self = this;
    var alEnable = true;
    if(self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != ''){
      alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
    }
    if (alEnable === true && typeof BCActionList !== 'undefined') {
        if (typeof bcActionList === 'undefined') {
            bcActionList = new BCActionList();
        }else{
          if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
              bcActionList.initFlag = false;
              bcActionList.alInit(bcSfFilterParams, bcAlParams);
          } else {
              bcActionList.alInit();
          }
        }
    }
    /* end-initialize-bc-al */
    $(document).ready(function() {
        theme.init();
        var sections = new theme.Sections();
        sections.register('collection-template', theme.Collection);
    });
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const page = urlParams.get('page');
    if (page && page >=2 && !document.querySelector("#bc-sf-filter-right .load-previous-page")) {
        document.getElementById("bc-sf-filter-right").insertAdjacentHTML("afterbegin", `<div class="load-previous-page"><a href="/collections/new-arrivals?page=${page - 1}" class="load-previous-page__btn">Load Previous Page</a></div>`);
    }
};

// Build placeholder for Collage product
BCSfFilter.prototype.buildPlaceholderProductExtra = function(eventType){
    var display = this.queryParams.display;
    if(typeof display !== 'undefined' && display == 'collage') {
        var html = bcSfFilterTemplate.skeletonProductCollage;
        if (this.isDefaultPaginationType() || (!this.isDefaultPaginationType() && eventType != 'page')) {
            jQ(this.getSelector('products')).html('');
        }
        jQ(this.getSelector('products')).append(html);
    }
}

BCSfFilter.prototype.buildAddToCartOptions = function(data){
    var optionsHtml = '';
    data.variants.map(function(variant) {
        optionsHtml += variant.available ? `
            <button
                class="add-to-cart-btn grid-product__option"    
                data-variant-id="${variant.id}"
            >
                ${variant.option1}
            </button>
        ` : ''
    })
    return optionsHtml
}

Shopify.handleize = function (str) {
    str = str.toLowerCase();

    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
    
    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], "");
    }

    str = str.replace(/\W+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/, "");
    }

    return str
}

// BCSfFilter.prototype.buildFilterTreeMobileButton = function(a) {
//     console.log(a)
//     var b = !1;
//     if (a.hasOwnProperty("filter") && a.filter.hasOwnProperty("options") && a.filter.options.length > 0)
//         for (var c = a.filter.options, d = 0; d < c.length; d++)
//             if (this.checkShowFilterOption(c[d])) {
//                 b = !0;
//                 break
//             }
//     if (b) {
//         var e = this.getSelector("filterTreeMobile")
//           , f = this.getSelector("filterTreeMobileButton")
//           , g = !1
//           , h = this.class.mobileButtonOpen
//           , i = this.getSettingValue("label.refineMobile");
//         jQ(f).hasClass(h) && (g = !0,
//         i = this.getSettingValue("label.refineMobileCollapse"));
//         var j = this.getTemplate("filterTreeMobileButton").replace(/{{label}}/g, i);
//         jQ(e).html(j),
//         g && jQ(f).addClass(h),
//         this.buildFilterTreeMobileButtonEvent()
//     }
// }

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};
